module.exports = function (bootstrap) {
    bootstrap.directive('mobileTableEmployer', ["modal", "navigation", "brand", "services", "session", "$state", "$cookies", 'orderByFilter', function (modal, navigation, brand, services, session, $state, $cookies, orderBy) {
        return {
            scope: {
                mobileTableEmployer: "=",
                tableData: "=",
                headers: "=",
                titleField: "=",
                // idField is set in the html that instantiates the directive as data-id-field
                idField: "@",
                buttonLabel: "@",
                docField: "@",
                downloadMethod: "&",
                mobileTableMethod: "&",
                // statePath is set in the html that instantiates the directive as data-state-path
                statePath: "@"
            },
            replace: false,
            template: require('directives/hmhs/mobileTable.html'),
            link: function ($scope) {
                if (!$scope.tableData.titles) { console.error('$scope.tableData.titles was not passed to mobile-table-employer directive') }
                if ($scope.headers.length==0) { console.error('$scope.headers was not populated in mobile-table-employer directive') }
                // w o a pagination obj the table will not display
                if (!$scope.tableData.pagination) { console.error('$scope.tableData.pagination was not passed to mobile-table-employer directive') }
                $scope.tableData = $scope.tableData ? $scope.tableData : {
                    orderBy :  null,
                    filterBy: "",
                    pagination: {
                        page: 1,
                        itemsPerPage: 5
                    }
                };
                // *******************************************************************************************************
                //  BUTTONS and CHECKBOXES (controls) IN DRAWERS
                //  - a default button displays in the drawer IF you have populated data-state-path, which populate statePath
                //  - that default button will go to statePath when clicked
                //  - pass in query params for this as comma delimited string in id-field
                //
                //  - for a button or checkbox click that runs a function from the calling controller
                //      - if the target method in the parent controller is $scope.deleteEnroll = function(theRollObj)
                //      - pass the method name in like data-mobile-table-method="deleteEnroll(theRollObj)"
                //      - create the param in this controller like var param = {theRollObj: theRow}
                //
                //      - in the parent controller you do this:
                //      - in each data row where you want the button to appear, add an array named controlsInRow
                //      - with an object like this
                //              var theButton = {
                //                  type: "aButton",
                //                  theLabel: 'Resend Email'
                //                 }
                //                  item.controlsInRow = [];
                //                  item.controlsInRow.push(theButton);
                // *******************************************************************************************************
                $scope.sortBy = $scope.tableData.orderBy || null;
                $scope.sort = function (propertyName) {
                    $scope.rowData = orderBy($scope.rowData, $scope.sortBy, false);
                };
                $scope.$watch('mobileTableEmployer', function () {
                    // this runs when the service returns with the data
                    $scope.rowData = $scope.mobileTableEmployer;
                    //debugger;
                });
                $scope.headerOptions = [];
                angular.forEach($scope.headers, function (option) {
                    if (option.name != '') {
                        $scope.headerOptions.push(option);
                    }
                });
                $scope.mobileClickHandler = function(theRow) {
                    if (!$scope.mobileTableMethod) { console.error('$scope.mobileTableMethod is not in mobileClickHandler in mobile-table directive') }
                    if (!$scope.idField) { console.error('$scope.idField is not in mobileClickHandler in mobile-table directive') }
                    if ($scope.idField == 'clientNumber,loginId,isAnEdit') {
                        // we know that that ^ is from CSUWEB plan-admin-list, for the ResendEmail method
                        var param = {theLoginId: theRow.loginId}
                    } else if ($scope.idField == 'ssn') {
                        // we know that that ^ is from enrollmentsInProcess
                        var param = {theRollObj: theRow}
                    } else if ($scope.idField == 'reportFile') {
                        // we know that that ^ is from Reports page
                        var param = {fileName: theRow.reportFile}
                    } else {
                        console.error('mobileClickHandler in mobileTableEmployer directive is being used in an unexpected way.');
                    }
                    $scope.mobileTableMethod(param);
                }
                $scope.checkboxChangeHandler = function(theRow) {
                    if (!$scope.mobileTableMethod) { console.error('$scope.mobileTableMethod is not in checkboxChangeHandler in mobile-table directive') }
                    if (!$scope.idField) { console.error('$scope.idField is not in checkboxChangeHandler in mobile-table directive') }
                    if ($scope.idField == 'groupEntitlement') {
                        // we know that that ^ is from CSUWEB add-plan-admin groupEntitlements DIRECTIVE
                        var param = {theRow: theRow}
                    } else {
                        console.error('checkboxChangeHandler in mobileTableEmployer directive is being used in an unexpected way.');
                    }
                    $scope.mobileTableMethod(param);

                }

                $scope.downloadRelay = function (data) {
                    if (!$scope.idField) { console.error('$scope.idField is not in downloadRelay in mobile-table directive') }
                    if (!$scope.downloadMethod) { console.error('$scope.downloadMethod is not in downloadRelay in mobile-table directive') }
                    var localsMap = {};
                    localsMap[$scope.idField] = data[$scope.idField];
                    $scope.downloadMethod(localsMap);
                };
                $scope.goHere = function (row) {
                    // NOTE: the next two properties are populated in the html that instantiates the directive
                    if (!$scope.idField) { console.error('$scope.idField is not in goHere function in mobile-table directive') }
                    // if statePath is missing the click inside the expanded drawer will not go anywhere
                    if (!$scope.statePath) { console.error('$scope.statePath is not in goHere function in mobile-table directive') }
                    var params = {};
                    // more than one param may be needed. If so they are sent in like
                    //                  data-id-field="clientNumber,loginId,isAnEdit"
                    var arrPs = ($scope.idField).split(',');
                    for (var i=0; i<arrPs.length; i++) {
                        var propertyName = arrPs[i];
                        var propertyValue = row[arrPs[i]];
                        params[propertyName] = propertyValue;
                    }
                    var goTo = $scope.statePath.toString();
                    $state.go(goTo, params);
                };
                $scope.hideRow = function (row, header) {
                    if (!header) { console.error('header was not passed to the hidRow function mobile-table directive') }
                    if (!header.dataKey) { console.error('header.dataKey was not passed to the hideRow function in the mobile-table directive') }
                    if (!row) { console.error('row was not passed to the hideRow function in the mobile-table directive') }
                    if (header.name == '' && row[header.dataKey] == true) {
                        //download row
                        return false;
                    }
                    else if (row[$scope.titleField] == row[header.dataKey]) {
                        return true;
                    } else if (row[header.dataKey] && row[header.dataKey].length > 0) {
                        return false;
                    }
                    return true;
                };

            }
        };
    }]);
};
